import React from 'react';
import PropTypes from 'prop-types';

import {Box, Stack, Typography} from 'views/components';
import {Translate, MarkdownViewer, HoverToolBox, useNavigate} from 'views/module';

const DescriptionBox = (props) => {
  const [toolbar, setToolbar] = React.useState(false);

  const {jobData} = props;

  const description = jobData.description.short;
  const anchorRef = React.useRef();
  const navigate = useNavigate();

  const onMouseOver = () => {
    setToolbar(true);
  };

  const onMouseLeave = () => {
    setToolbar(false);
  };

  const editJob = () => {
    navigate(`/career/${jobData.jobRn}/edit`);
  };

  return (
    <Box
      ref={anchorRef}
      onMouseEnter={onMouseOver}
      onMouseLeave={onMouseLeave}
    >
      <Stack >
        <Typography variant="subtitle1" sx={{fontWeight: 500}}>
          <Translate expression="caregiver.CaregiverDetail.Correspondance.Header.Description" />
        </Typography>
        <MarkdownViewer
          value={description}
          truncate
          truncateLine={8}
        />
        <HoverToolBox
          toolBar={toolbar}
          anchorEl={anchorRef.current}
          onClickEdit={() => editJob(true)}
          copiedText={description}
          hideTool={{
            emoji: true,
            copy: true,
            delete: true,
          }}
        />
      </Stack>
    </Box>
  );
};

DescriptionBox.propTypes = {
  jobData: PropTypes.object.isRequired,
};

export default React.memo(DescriptionBox);
